var exports = {
  "vW": "x61f99309--44df93--inner",
  "Qs": "x61f99309--44df93--content",
  "qr": "x61f99309--44df93--footer",
};

module.exports = exports;
